module.exports = __webpack_public_path__ + "static/media/sf1.0cb138ce.jpg";